import { useMemo } from 'react';
import { FlowDef } from '@wix/gg-components/orchestrator';

const REDIRECT_EXPIRY_MS = 10 * 60 * 1000; // 10 minutes

interface PendingRedirect {
  returnToStepId: string;
  timestamp: number;
}

export function useInitialFlowIndex(
  flow: FlowDef[],
  pendingRedirect: PendingRedirect | null,
  currentStepId: string | null,
  isLoggedIn: boolean,
  setCurrentStepId: (id: string) => void,
): number {
  return useMemo(() => {
    if (pendingRedirect) {
      const isExpired = Date.now() - pendingRedirect.timestamp > REDIRECT_EXPIRY_MS;
      if (!isExpired) {
        const index = flow.findIndex((item) => item.type === 'step' && item.id === pendingRedirect.returnToStepId);
        if (index >= 0) {
          setCurrentStepId(pendingRedirect.returnToStepId);

          if (isLoggedIn) {
            const nextStepIndex = flow.findIndex((item, idx) => idx > index && item.type === 'step');
            return nextStepIndex >= 0 ? nextStepIndex : index;
          }

          return index;
        }
      }
    }

    if (currentStepId) {
      const index = flow.findIndex((item) => item.type === 'step' && item.id === currentStepId);
      return index >= 0 ? index : 0;
    }

    return 0;
  }, [flow, pendingRedirect, currentStepId, isLoggedIn, setCurrentStepId]);
}
